import { FC } from "react";

export const EllipsisPlaceholder: FC = () => (
  <div className="flex h-8 w-8 items-center justify-center">
    <span className="leading-base text-grey text-xs font-medium">...</span>
  </div>
);
